(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-offerte-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ---------- Rail nav ---------- */
  const rail = document.querySelector('[data-rail]');
  if(rail){
    const prev=document.querySelector('.rail-prev'), next=document.querySelector('.rail-next');
    const step = ()=> rail.clientWidth * 0.9;
    prev && prev.addEventListener('click', ()=> rail.scrollBy({left:-step(), behavior:'smooth'}));
    next && next.addEventListener('click', ()=> rail.scrollBy({left: step(), behavior:'smooth'}));
  }

  /* ---------- Trust marquee ---------- */
  const marquee = document.querySelector('[data-marquee]');
  if(marquee){
    const speed = Number(marquee.getAttribute('data-speed')) || 5;
    const track = marquee.querySelector('[data-track]');
    let raf, pos = 0;
    const tick = ()=>{
      pos -= speed/30;
      track.style.transform = `translateX(${pos}px)`;
      const firstSetWidth = track.scrollWidth / 2;
      if(Math.abs(pos) >= firstSetWidth){ pos = 0; }
      raf = requestAnimationFrame(tick);
    };
    const pause = ()=> cancelAnimationFrame(raf);
    const play  = ()=> { cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); };
    marquee.addEventListener('mouseenter', pause);
    marquee.addEventListener('mouseleave', play);
    play();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerte-aanvraag-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var configField = document.getElementById('OffertemandConfig');
  var noteField   = document.getElementById('OffertemandNote');

  if (!configField && !noteField) return;

  function mapProps(item) {
    var size    = '';
    var colors  = '';
    var qty     = '';
    var storage = '';

    if (item.properties) {
      Object.keys(item.properties).forEach(function(key) {
        var val = item.properties[key];
        if (!val) return;

        var k = (key || '').toLowerCase();

        if (k.indexOf('formaat') !== -1) {
          size = val;
        } else if (k.indexOf('kleur') !== -1) {
          colors = val;
        } else if (k.indexOf('opslag') !== -1 || k.indexOf('levering') !== -1) {
          storage = val;
        } else if (
          k.indexOf('oplage')      !== -1 ||
          k.indexOf('jaarverbruik')!== -1 ||
          k.indexOf('verbruik')    !== -1
        ) {
          qty = val;
        }
      });
    }

    if (!size && item.variant_title) {
      size = item.variant_title;
    }

    return {
      size:    size,
      colors:  colors,
      qty:     qty,
      storage: storage
    };
  }

  async function getCart() {
    var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) { return null; }
    return await res.json();
  }

  async function fillFields() {
    try {
      var cart = await getCart();
      if (!cart) return;

      // Opmerking bij offertemand = cart note
      if (noteField) {
        noteField.value = cart.note || '-';
      }

      if (!configField) return;

      if (!cart.items || !cart.items.length) {
        configField.value = 'Offertemand is leeg.';
        return;
      }

      var lines = cart.items.map(function(item, index) {
        var p = mapProps(item);

        return [
          '- Product: ' + item.product_title,
          '  Formaat: ' + (p.size    || '—'),
          '  GSM:',
          '  Kleuren: ' + (p.colors  || '—'),
          '  Oplage: '  + (p.qty     || '—'),
          '  Opslag: '  + (p.storage || '—'),
          '  Aantal configuraties: ' + (item.quantity || 1)
        ].join('\n');
      }).join('\n\n');

      configField.value = 'Offertemand configuraties:\n\n' + lines;
    } catch (e) {
      console.error('Kon offertemand niet uitlezen', e);
    }
  }

  fillFields();
});

  } catch(e) { console.error(e); }
})();
})();
